import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { CutVM, OperationResult } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class CutService {

  cutApi = `${environment.apiUrl}/Cut`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  getAll() {
    return this.http.get(this.cutApi).pipe(
      map((response: OperationResult<CutVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.cutApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CutVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
